{
  "pages_records.kind.task": "Görev",
  "pages_records.kind.project": "Proje",
  "pages_records.kind.plan": "Plan",
  "pages_records.kind.routine": "Rutin",
  "pages_records.kind.period": "Dönem",
  "pages_records.kind.span": "Dönem",
  "pages_records.kind.note": "Not",
  "pages_records.kind.life_area": "Yaşam alanı",
  "pages_records.kind.life_schema": "Yaşam tablosu",
  "pages_records.kind.life_item": "Yaşam kaydı",
  "pages_records.kind.goal": "Hedef",
  "pages_records.kind.decision": "Karar",
  "pages_records.kind.moment": "Günlük kaydı",
  "pages_records.kind.knowledge_item": "Bilgi",
  "pages_records.kind.saved_view": "Kayıtlı görünüm",
  "pages_records.property.schedule_date": "Tarih",
  "pages_records.property.priority": "Öncelik",
  "pages_records.property.estimate_minutes": "Tahmini süre",
  "pages_records.property.description": "Açıklama",
  "pages_records.property.content": "İçerik",
  "pages_records.property.start_date": "Başlangıç",
  "pages_records.property.end_date": "Bitiş",
  "pages_records.property.target_date": "Hedef tarih",
  "pages_records.property.frequency": "Tekrar",
  "pages_records.property.frequency_count": "Kaç kez",
  "pages_records.property.section": "Bölüm",
  "pages_records.priority.low": "Düşük",
  "pages_records.priority.normal": "Normal",
  "pages_records.priority.high": "Yüksek",
  "pages_records.frequency.daily": "Her gün",
  "pages_records.frequency.times_per_week": "Haftada birkaç kez",
  "pages_records.frequency.every_x_days": "Birkaç günde bir",
  "pages_records.section.tracking": "Takip",
  "pages_records.section.guide": "Rehber",
  "pages_records.placeholder.task": "Görev adı",
  "pages_records.placeholder.project": "Proje adı",
  "pages_records.placeholder.plan": "Plan adı",
  "pages_records.placeholder.routine": "Rutin adı",
  "pages_records.placeholder.period": "Dönem adı",
  "pages_records.placeholder.span": "Dönem adı",
  "pages_records.placeholder.note": "Not başlığı",
  "pages_records.placeholder.life_area": "Yaşam alanı adı",
  "pages_records.placeholder.life_schema": "Tablo adı",
  "pages_records.placeholder.default": "Kayıt adı",
  "pages_records.placeholder.text": "Yazın…",
  "pages_records.add_property": "Özellik ekle",
  "pages_records.edit_property": "{{property}} düzenle",
  "pages_records.clear_property": "Temizle",
  "pages_records.no_properties": "Eklenecek başka özellik yok",
  "pages_records.empty_value": "Boş",
  "pages_records.title_label": "Başlık",
  "pages_records.complete_task": "Görevi tamamla",
  "pages_records.reopen_task": "Görevi yeniden aç",
  "pages_records.open_record": "Kaydı aç",
  "pages_records.in_trash": "çöp kutusunda",
  "pages_records.unavailable": "kayıt kullanılamıyor",
  "pages_records.untitled": "Adsız",
  "pages_records.saving": "Kaydediliyor…",
  "pages_records.save_error": "Kaydedilemedi.",
  "pages_records.load_error": "Yüklenemedi.",
  "pages_records.loading": "Yükleniyor…",
  "pages_records.cancel": "Vazgeç",
  "pages_records.create": "Oluştur",
  "pages_records.status.pending": "Bekliyor",
  "pages_records.status.open": "Açık",
  "pages_records.status.active": "Etkin",
  "pages_records.status.completed": "Bitti",
  "pages_records.status.cancelled": "İptal edildi",
  "pages_records.status.canceled": "İptal edildi",
  "pages_records.status.skipped": "Atlandı",
  "pages_records.status.trashed": "Çöp kutusunda",
  "pages_records.status.archived": "Arşivlendi",
  "pages_records.status.draft": "Taslak",
  "pages_records.status.paused": "Duraklatıldı",
  "pages_records.composer.title": "Kayıt ekle",
  "pages_records.composer.search": "Kayıt arayın ya da yeni bir ad yazın",
  "pages_records.composer.search_label": "Kayıt ara",
  "pages_records.composer.type": "Kayıt türü",
  "pages_records.composer.results": "Sonuçlar",
  "pages_records.composer.create_named": "Yeni oluştur: «{{title}}»",
  "pages_records.composer.create_blank": "Yeni {{kind}} oluştur",
  "pages_records.composer.no_results": "Eşleşen kayıt yok",
  "pages_records.composer.create_unavailable": "Bu tür burada oluşturulamıyor.",
  "pages_records.composer.back": "Aramaya dön",
  "pages_records.composer.insert": "Oluştur ve ekle",
  "pages_records.composer.context_parent": "Bu görevin altına eklenecek.",
  "pages_records.composer.context_plan": "Bu plana bağlanacak.",
  "pages_records.composer.context_project": "Bu projeye bağlanacak.",
  "pages_records.composer.context_table": "Bu tabloya eklenecek.",
  "pages_records.composer.area": "Alan",
  "pages_records.composer.select_area": "Bir alan seçin",
  "pages_records.composer.table": "Tablo",
  "pages_records.composer.select_table": "Bir tablo seçin",
  "pages_records.composer.schema_kind": "Tablo türü",
  "pages_records.composer.schema_kind.record": "Kayıt defteri",
  "pages_records.composer.schema_kind.entity": "Nesne",
  "pages_records.composer.schema_kind.guide_entry": "Rehber maddesi",
  "pages_records.composer.time_mode": "Zaman",
  "pages_records.composer.time_mode.none": "Zamansız",
  "pages_records.composer.time_mode.date": "Gün",
  "pages_records.composer.time_mode.instant": "An",
  "pages_records.composer.time_mode.interval": "Aralık",
  "pages_records.composer.fields": "Alanlar",
  "pages_records.composer.device_timezone": "Cihaz saat dilimi: {{zone}}",
  "pages_records.composer.name": "Ad",
  "pages_records.composer.date": "Tarih",
  "pages_records.composer.start": "Başlangıç",
  "pages_records.composer.end": "Bitiş",
  "pages_records.tool.tasks": "Görevler",
  "pages_records.tool.calendar": "Takvim",
  "pages_records.tool.saved_view": "Kayıtlı görünüm",
  "pages_records.tool.focus": "Odak",
  "pages_records.tool.attachment": "Dosya",
  "pages_records.tool.count": "{{value}} kayıt",
  "pages_records.tool.empty_tasks": "Burada henüz görev yok.",
  "pages_records.tool.empty_view": "Bu görünümde henüz bir şey yok.",
  "pages_records.tool.empty_table": "Henüz kayıt yok.",
  "pages_records.tool.new_task": "Yeni görev",
  "pages_records.tool.new_row": "Yeni kayıt",
  "pages_records.tool.more": "Daha fazla göster",
  "pages_records.tool.attaches_plan": "«{{name}}» planına eklenir",
  "pages_records.tool.attaches_project": "Bu projeye eklenir",
  "pages_records.tool.attaches_standalone": "Plana ya da projeye bağlanmadan oluşturulur",
  "pages_records.tool.configure_life": "Bu blok için bir yaşam tablosu seçin.",
  "pages_records.tool.live": "Canlı görünüm",
  "pages_records.tool.download": "İndir",
  "pages_records.tool.media_unavailable": "Bu dosya gösterilemiyor.",
  "pages_records.tool.view_date": "Tarih",
  "pages_records.tool.view_mode": "Görünüm",
  "pages_records.tool.calendar.day": "Gün",
  "pages_records.tool.calendar.week": "Hafta",
  "pages_records.tool.calendar.month": "Ay",
  "pages_records.tool.calendar.year": "Yıl",
  "pages_records.tool.add": "Ekle",
  "pages_records.tool.retry": "Yeniden dene"
}
